import React, { FC } from 'react'

import { BadgeTagList } from '..'

import { TagsProps } from './Tags.props'

const Tags: FC<TagsProps> = ({ tags, labelTagsIds, onToggleTag, setShowAlert }) => (
  <form className="label-form">
    <h4 className="label-form__title">Tags</h4>
    <BadgeTagList tags={tags} activeTagsIds={labelTagsIds} onToggleTag={onToggleTag} setShowAlert={setShowAlert} />
  </form>
)

export default Tags
